import { render } from "./pop-up.vue?vue&type=template&id=00d8548e&scoped=true"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-00d8548e"

export default script